/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useState } from 'react';

import axios from 'axios';
import Header from '../../Components/Header/Header'
import Navbar from '../../Components/Navbar/Navbar'
import FormInput from '../../Components/FormInput/FormInput'
import PrimaryButton from '../../Components/Buttons/PrimaryButton';

import { toast } from 'react-hot-toast';
import { useContext } from 'react';
import { authContext } from '../../store/AuthContext';
import { useHistory } from 'react-router-dom';

const Users = () => {

    const serverURL = `${process.env.REACT_APP_SERVER_URL}/api/users`
    const defaultUserState = {
        name: '',
        email: '',
        password: '',
        phone: '',
        adminType: ''
    }

    const history = useHistory();
    const token = JSON.parse(localStorage.getItem('token'));

    const authCtx = useContext(authContext);

    if (authCtx.adminType !== 'super') {
        history.push('/sites');
    }

    const [users, setUsers] = useState([]);
    const [currUser, setCurrUser] = useState(defaultUserState)
    const [editMode, setEditMode] = useState(false);

    const isDataCorrect = () => {
        if (!currUser.name || currUser.name.length === 0) {
            return [false, 'Kindly provide us with a name!']
        }

        if (!currUser.email || currUser.email.length === 0) {
            return [false, 'Kindly provide us with an email!']
        }

        if (!editMode && (!currUser.password || currUser.password.length === 0)) {
            return [false, 'Kindly provide us with a password!']
        }

        if (!currUser.phone || currUser.phone.length === 0) {
            return [false, 'Kindly provide us with a phone number!']
        }

        if (!currUser.adminType || currUser.adminType.length === 0) {
            return [false, 'Kindly provide us with Admin Type!']
        }

        return [true, ''];
    }

    const getData = async () => {

        const res = await toast.promise(axios({
            url: serverURL,
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }),
            {
                loading: 'Fetching...',
                success: 'Data fetched successfully!',
                error: 'Could not get the data.',
            }
        )

        const { data } = res.data;

        setUsers(data);
    }

    const postData = async (event) => {
        event.preventDefault();

        const inputDataStatus = isDataCorrect()

        if (!inputDataStatus[0]) {
            return toast.error(inputDataStatus[1]);
        }

        const res = await toast.promise(axios({
            url: serverURL,
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            data: currUser
        }), {
            loading: 'Creating...',
            success: 'User created successfully!',
            error: "Something went wrong! Couldn't create the user with this data."
        })

        if (res && res.status === 200) {
            const newUsers = [...users];
            newUsers.push(res.data.data);
            setUsers(newUsers);
            setCurrUser(defaultUserState);
            return;
        }

        setCurrUser(defaultUserState);
    }

    const editDataHandler = async (id) => {
        const userToEdit = users.filter((user) => user._id === id);
        setCurrUser(userToEdit[0]);
        setEditMode(true);
    }

    const saveEditHandler = async (event) => {
        event.preventDefault();

        const inputDataStatus = isDataCorrect()

        if (!inputDataStatus[0]) {
            return toast.error(inputDataStatus[1]);
        }

        const id = currUser._id;

        try {

            const res = await axios({
                url: `${serverURL}/${id}`,
                method: 'PATCH',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: currUser
            })

            if (res && res.status === 200) {
                toast.success('User successfully updated! 😁')
                const newUsers = [...users];

                newUsers.forEach((user, idx) => {
                    if (user._id === id) {
                        newUsers[idx] = {
                            ...currUser,
                            password: undefined
                        }
                        return;
                    }
                })

                setUsers(newUsers);
                setCurrUser(defaultUserState);
                setEditMode(false);
                return;
            }

            setCurrUser(defaultUserState);
            setEditMode(false);
            return toast.error("Couldn't update the user with this data. Kindly check your data and try again! ❌")

        } catch (error) {
            setEditMode(false);
            setCurrUser(defaultUserState);
            return toast.error('Something went wrong! 😞')
        }

    }

    const deleteData = async (id) => {

        window.alert('Are you sure ?')

        try {

            const res = await axios({
                url: `${serverURL}/${id}`,
                method: 'delete',
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            })

            if (res && res.status === 200) {
                toast.success('User deleted successfully. 😁');
                const newUsers = users.filter((user) => user._id !== id);
                setUsers(newUsers)
                return;
            }

            return toast.error("User couldn't be deleted. Try again later!")

        } catch (error) {
            return toast.error('Something went wrong! 😞')
        }

    }

    const togglePasswordVisibilityHandler = () => {
        if (document.getElementById('password').type === 'password') {
            document.getElementById('password').type = 'text'
        } else {
            document.getElementById('password').type = 'password'
        }
    }

    const inputChangeHandler = (event) => {

        console.log(event.target.name);
        console.log(event.target.value);

        setCurrUser((prevState) => {
            return {
                ...prevState,
                [event.target.name]: event.target.value
            }
        })
    }

    useEffect(() => {
        getData()
    }, [])

    return (
        <Fragment>
            <Header />
            <Navbar />
            <div className='container'>
                <div className='row'>
                    <div class="col-lg-12 mt-20">
                        <h3>Admin Users List</h3>
                        <hr />
                    </div>
                    <div className='col-lg-8'>
                        <table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Admin Type</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    users && users.map((user) => {
                                        return (
                                            <tr key={user._id} >
                                                <td>{user.name}</td>
                                                <td>{user.email}</td>
                                                <td>{user.adminType}</td>
                                                <td>
                                                    <div className='d-flex justify-content-center gap1' >
                                                        <button className="btn-blue-sm" style={{ marginRight: '10px' }} onClick={() => editDataHandler(user._id)} >EDIT</button>
                                                        <button onClick={() => deleteData(user._id)} className="btn-red-sm">DELETE</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className='col-lg-4'>
                        <form className='user-form side-form' >
                            <FormInput autoComplete='off' onChange={inputChangeHandler} value={currUser.name} id='name' type='text' label='Name' />
                            <FormInput autoComplete='off' onChange={inputChangeHandler} value={currUser.email} id='email' type='email' label='Email' />
                            <div className='d-flex' >
                                <FormInput autoComplete='off' onChange={inputChangeHandler} value={currUser.password} style={{ flex: '1' }} id='password' type='password' label='Password' />
                                <PrimaryButton style={{ padding: '16px', margin: '1rem 0', alignSelf: 'flex-end', lineHeight: '0px' }} type='button' onClick={togglePasswordVisibilityHandler} ><ion-icon name="eye-off-outline"></ion-icon></PrimaryButton>
                            </div>
                            <FormInput autoComplete='off' onChange={inputChangeHandler} value={currUser.phone} id='phone' type='text' label='Phone' />
                            <label>Select Admin Type</label>
                            <select className='form-control shadow-none mb-10' name='adminType' onChange={inputChangeHandler} value={currUser.adminType} >
                                <option value="">Admin Type ?</option>
                                <option value="super">Super</option>
                                <option value="data">Data</option>
                                <option value="lead">Lead</option>
                            </select>
                            <PrimaryButton onClick={editMode ? saveEditHandler : postData} type='submit'>{
                                editMode ? 'Edit' : 'Add'
                            }</PrimaryButton>
                        </form>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Users